import React, { Component } from "react";
import { Link } from "react-router-dom";
import queryString from 'query-string';
import SignHeader from "../component/SignHeader";
import Header from "../component/Header";

import Button from "@material-ui/core/Button";

import "../scss/style.scss";
import "../scss/sign.scss";

import Dialog from "@material-ui/core/Dialog";

import cookie from 'react-cookie';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-125086411-4');

//var DEBUG13=true;
var DEBUG13=false;

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headerTitle: "더책",
            userid: '',
            passwd: '', orgid: '', self: this, loading: false, loadingorg: true, totalcount: 0, aaa: props, orglist: []
        };
    }

    dologin(gid, uid, type) {
        this.state.self.removeCookie();
        this.state.loading = true;
        var arg = {
            type: type,
            orgid: gid, 
            userid: uid, 
            passwd: this.state.passwd
        };
        //let struserid = cookie.load("userid");
        //let struserdbid = cookie.load("userdbid");

        //alert(JSON.stringify(this.state));
        fetch(`/api/AB/dologin`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(arg)
        })
            .then(response => response.json())
            .then(data => {
                //alert(JSON.stringify(data));
                this.state.loading = true;
                if (data.R.RC === 250) {
                    this.state.self.setCookie2(
                        data.dicresult.userinfo.userid,
                        data.dicresult.userinfo.id,
                        data.dicresult.userinfo.orgid,
                        data.dicresult.userlogoncount,
                        data.dicresult.userlendcount,
                        data.dicresult.userinfo.org.orgname,
                        data.dicresult.sbc
                    );
                    this.state.aaa.history.replace(data.dicresult.userinfo.org.orgWebsite);
                }
                else {
                    var org = data.dicresult.userinfo;
                    if (typeof org != 'undefined')
                        this.state.self.setCookie1(
                            data.dicresult.userinfo.orgid,
                            data.dicresult.userinfo.org.orgname,
                            data.dicresult.userinfo.org.orgWebsite
                        );
                    this.state.aaa.history.replace('/signin');
                }
            });
    }

    setCookie1(orgid, orgname, rootpath) {
        let d = new Date();
        d.setTime(d.getTime() + (12 * 60 * 60 * 1000));
        cookie.save("orgid", orgid, { path: "/", expires: d });
        cookie.save("orgname", orgname, { path: "/", expires: d });
        cookie.save("root", rootpath, { path: "/", expires: d });
    };

    setCookie2(userid, strdbid, orgid, logoncount, llendbookcount, orgname, sbc) {
        let d = new Date();
        d.setTime(d.getTime() + (12 * 60 * 60 * 1000));
        cookie.save("userid", userid, { path: "/", expires: d });
        cookie.save("userdbid", strdbid, { path: "/", expires: d });
        cookie.save("orgid", orgid, { path: "/", expires: d });
        cookie.save("lc", logoncount, { path: "/", expires: d });
        cookie.save("lendc", llendbookcount, { path: "/", expires: d });
        cookie.save("orgname", orgname, { path: "/", expires: d });
        cookie.save("sbc", sbc, { path: "/", expires: d });
    };
    removeCookie(userid) {
        cookie.remove("userid", { path: '/' });
        cookie.remove("userdbid", { path: '/' });
        cookie.remove("orgid", { path: '/' });
        cookie.remove("lc", { path: '/' });
        cookie.remove("lendc", { path: '/' });
        cookie.remove("orgname", { path: '/' });
        cookie.remove("sbc", { path: '/' });
    };

    logPageView() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.pageview(window.location + "&orgid=" + cookie.load("orgid"));
    }

    render() {
        this.logPageView();

        if (this.state.loading === false) {
            let url = this.props.location.search;
            url = url.replace(/&amp;/g, '&');
            let params = queryString.parse(url);

            if (params != null) {
                var gid = params.gid;
                var uid = params.uid;
                var type = params.type;

                if (typeof gid === 'undefined' || typeof uid === 'undefined') {
                    this.state.self.removeCookie(); 
                    this.state.aaa.history.replace('/signin');
                }
                else
                    this.dologin(gid, uid, type);
            }
            else {
                this.state.aaa.history.replace('/signin');
            }
        }

        return (
            <React.Fragment>
            </React.Fragment>
        );
    }
}

export default Home;